import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateTimeDisplay from "../Shared/DateTimeDisplay";
import {
  getDriverBundleSubscriptions,
  cancelDriverBundleSubscriptionCycles,
  getDriverChargingSites,
} from "../../actions/commonActions";
import { setPageTitle } from "../../utils/helper";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";
import NewSiteModal from "../Shared/NewSiteModal";
import "./PlanSelection.css"

export default function () {
  const dispatch = useDispatch();
  const history = useHistory();

  const { driverBundleSubscriptions, driverChargingSites } = useSelector(
    (reduxState) => reduxState.common
  );

  console.log("Driver Charging Sites array in plan selection:", driverChargingSites)

  // Here;
  const [isCurrentStationActive, setIsCurrentStationActive] = useState(false);
  const [showModal, setShowModal] = useState(false);

  console.log("DRIVER PLANS: ", { driverBundleSubscriptions, driverChargingSites })

  ///////////Add  Station///////////////
  const [addNewSite, setAddNewSite] = useState(false);
  /////////////////////////////////////

  useEffect(() => {
    getDriverBundleSubscriptions(dispatch);
    setPageTitle("Driver Plans");
  }, []);

  useEffect(() => {
    const selectedStationId = localStorage.getItem("ev_charging_site_id");
    const isActiveChargingSitesSelected = driverChargingSites.filter(
      (site) =>
        site.ev_charging_site_id == selectedStationId &&
        site.is_active_flag !== 0
    );
    setIsCurrentStationActive(isActiveChargingSitesSelected.length > 0);
  }, [driverChargingSites]);

  const onCancel = (e) => {
    cancelDriverBundleSubscriptionCycles(dispatch, e.target.id);
  };

  const addDriverPlan = () => {
    if (isCurrentStationActive) {
      history.push("/plan_selection");
    } else {
      setShowModal(true);
    }
  };

  const onCloseModal = () => {
    setShowModal(false);
    getDriverChargingSites(dispatch);
  };
  console.log("plan_plan", driverBundleSubscriptions)
  return (
    <div className="container mt-2 mr-3">
      <Modal
        show={showModal}
        centered
        backdrop="static"
        size="sm"
        onHide={onCloseModal}
      >
        <Modal.Header closeButton>
          <p>Please wait for your approval.</p>
        </Modal.Header>
      </Modal>
      <div class="row">
        <div class="col-12">
          <button
            className="btn btn-default float-right mb-2 w-30"
            onClick={addDriverPlan}
          >
            Add Plan
          </button>
          <button
            className="btn btn-default float-right mb-2 w-30 mr-2 "
            onClick={() => {
              setAddNewSite(true);
            }}
          >
            <i className="fa fa-plus-circle mr-1" aria-hidden="true"></i>
            Add Station
          </button>
        </div>
      </div>
      {(driverBundleSubscriptions.length > 0 && (
        <>
          <h1>
            Your Subscriptions
          </h1>
          {driverBundleSubscriptions &&
            driverBundleSubscriptions
              .filter(
                (s) => s.driver_bundle_subscription_status_code == "ACTIVE"
              )
              .map((s) => {
                return (
                  <div style={{flexDirection:"column"}} className="rounded mt-3 bg-grey text-dark p-3 bundle_main">
                    <div className="text_div">
                      <h4>{s.evChargingSite.name}</h4>
                      <h4>{s.evChargingSiteBundle.name.split(" ").slice(-1)[0].charAt(0).toUpperCase() + s.evChargingSiteBundle.name.split(" ").slice(-1)[0].slice(1)}</h4>
                      <h4> {s.evChargingSiteBundle.bundle_duration_type_code === "W" ? "Weekly" : s.evChargingSiteBundle.bundle_duration_type_code === "M" ? "Monthly" : null} </h4>
                      <p>
                        Renews: <DateTimeDisplay date={s.driverBundleSubscriptionCycle[0]
                          .cycle_end_date} />
                      </p>
                    </div>
                    <div style={{width:"30%"}} className="button_div">
                      <button
                        className="btn btn-danger"
                        id={s.driver_bundle_subscription_id}
                        onClick={onCancel}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                );
              })}
        </>
      )) || <p>You don't have any bundle subscriptions at the moment.</p>}
      {addNewSite && <NewSiteModal setAddNewSite={setAddNewSite} />}
    </div>
  );
}
